import Select, {
  ClearIndicatorProps,
  DropdownIndicatorProps,
  IndicatorsContainerProps,
  components,
} from "react-select";
import { CustomReactSelectProps } from "./interface";
import { Box } from "@chakra-ui/react";
import { ChevronDownIcon, CloseIcon } from "@chakra-ui/icons";

function IndicatorsContainer<T, M extends boolean = false>({
  ...props
}: IndicatorsContainerProps<T, M>) {
  return (
    <Box>
      <components.IndicatorsContainer {...props} />
    </Box>
  );
}

function DropdownIndicator<T, M extends boolean = false>({
  ...props
}: DropdownIndicatorProps<T, M>) {
  return (
    <components.DropdownIndicator {...props}>
      <ChevronDownIcon boxSize="22px" />{" "}
    </components.DropdownIndicator>
  );
}

function ClearIndicator<T, M extends boolean = false>({
  ...props
}: ClearIndicatorProps<T, M>) {
  return (
    <components.ClearIndicator {...props}>
      <CloseIcon boxSize="10px" />{" "}
    </components.ClearIndicator>
  );
}

function CustomReactSelect<T, M extends boolean = false>({
  size = "md",
  ...props
}: CustomReactSelectProps<T, M>) {
  return (
    <Select
      {...props}
      components={{
        IndicatorSeparator: undefined,
        IndicatorsContainer,
        DropdownIndicator,
        ClearIndicator,
      }}
      styles={{
        control: (baseStyles, state) => {
          return {
            ...baseStyles,
            borderColor: state.isFocused
              ? "var(--chakra-colors-primary)"
              : "#c2c4cc",
            boxShadow: "none",
            borderRadius: "var(--chakra-radii-md)",
            height: size === "sm" ? "32px" : "40px",
            width: "100%",
            minWidth: "280px",
            minHeight: "none",
            cursor: props.isSearchable ? "text" : "pointer",
          };
        },
        valueContainer: (baseStyles, state) => ({
          ...baseStyles,
          paddingLeft: "10px",
          margin: 0,
          paddingTop: 0,
          paddingBottom: 0,
        }),
        indicatorsContainer: (baseStyles, state) => ({
          ...baseStyles,
          height: size === "sm" ? "32px" : "40px",
        }),
        dropdownIndicator: (baseStyles, state) => ({
          ...baseStyles,
          paddingLeft: "8px",
          paddingRight: "8px",
          paddingTop: 0,
          paddingBottom: 0,
          cursor: "pointer",
        }),
        clearIndicator: (baseStyles, state) => ({
          ...baseStyles,
          paddingLeft: "8px",
          paddingRight: "8px",
          paddingTop: 0,
          paddingBottom: 0,
          cursor: "pointer",
        }),
        menu: (baseStyles) => ({
          ...baseStyles,
          boxShadow: "rgba(0, 0, 0, 0.08) 0px 2px 12px",
          borderRadius: "4px",
        }),
        menuList: (baseStyles) => ({
          ...baseStyles,
          padding: "12px 16px",
        }),
        option: (baseStyles, props) => {
          const isLast = props.data === props.options[props.options.length - 1];

          return {
            ...baseStyles,
            padding: "16px 0",
            lineHeight: "20px",
            borderBottom: !isLast ? "1px solid #EEF0F0" : "none",
            cursor: "pointer",
            color: props.isSelected ? "#4199d5" : "inherit",
            backgroundColor: props.isFocused ? "#FAFAFA" : "transparent",
            fontWeight: props.isSelected ? "bold" : 400,
          };
        },
      }}
    />
  );
}

export default CustomReactSelect;
